<div style="display: flex;flex-direction: column;width: 100%;">
    <div
        style="display: flex;justify-content: space-between;align-items: center; color:#545454;padding: 0.1rem 0.5rem;height: 45px;">
        <span mat-dialog-close style="cursor: pointer;">
            <mat-icon >close</mat-icon>
        </span>
    </div>
    <mat-divider></mat-divider>
</div>

<ng-container *ngTemplateOutlet="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? modeDesk: modeMobile"></ng-container>

<ng-template #modeDesk>
    <div style="display: flex;flex-wrap: wrap;margin: 0 auto;width: 100%;overflow: auto;height: calc(100% - 45px)"
        class="customscroll">
        <ng-container *ngTemplateOutlet="hotelinfo"></ng-container>
    </div>
</ng-template>

<ng-template #modeMobile>
    <div style="display: flex;flex-wrap: wrap;margin: 0 auto;width: 100%;overflow: auto;height: calc(100% - 60px)"
        class="customscroll">
        <ng-container *ngTemplateOutlet="hotelinfo"></ng-container>
    </div>
</ng-template>

<ng-template #myloading>
    <div style="display: flex;width: 100%;height: 100%;align-items: center;justify-content: center;">
        <div style="display: flex;justify-content: center;padding: .3rem; width: 100%;align-items: center;">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-template>

<ng-template #hotelinfo>
    <div style="display: flex;flex-direction: column;width: 100%;">
        <ng-container *ngIf="!sktvContent; else sktvhotelinfo">
            <div color="primary" style="margin: .5rem;">
                <ng-container *ngTemplateOutlet="hotelfotosname"></ng-container>
                <div style="display: flex;width: 100%;margin-top: 1rem;flex-direction: column;">
                    <span style="color: #545454eb;font-weight: 900;font-size: 1.2rem;">Hotelinformationen</span>
                    <ng-container *ngTemplateOutlet="touraddress"></ng-container>
                </div>
            </div>
            <ng-container *ngIf="!loading; else myloading">
                <div 
                    [innerHtml]="html | safehtml" class="vorteile"></div>
            </ng-container>
            <div style="display: flex;flex-direction: column;line-height: normal;margin: .5rem;font-weight: 700;">
                {{catalogfootertext}}</div>
        </ng-container>
    </div>
</ng-template>

<ng-template #hotelfotosname>
    <div style="display: flex;width: 100%;"
        [style.flex-direction]=" desktopTemplate === 'sm' || desktopTemplate === 'xs' || desktopTemplate === 'md' ? 'column' : 'row'">
        <div style="display:flex;width: 100%;height: 400px;position: relative;"
            [style.width]=" desktopTemplate === 'sm' || desktopTemplate === 'xs' || desktopTemplate === 'md' ? '100%' : '50%'">
            <imageslider (clickOnImg)="openImageModal($event)" [data]="images" class="imgCard">
            </imageslider>
            <div style="position: absolute;bottom: 14px;left: 0px; cursor: pointer;" (click)="openImageModal(0)">
                <div class="allbilds">
                    <mat-icon >view_module</mat-icon>
                    <span style="margin-left: .3rem;">Alle {{images?.length}} Bilder
                        anzeigen</span>
                </div>
            </div>
        </div>
        <div style="color:#545454; display: flex;flex-direction: column;justify-content: space-between;"
            [style.width]="desktopTemplate === 'sm' || desktopTemplate === 'xs' || desktopTemplate === 'md' ? '' : '50%'"
            [style.margin-left]="desktopTemplate === 'sm' || desktopTemplate === 'xs' || desktopTemplate === 'md' ? '' : '.5rem'">
            <div>
                <div style="display: flex;flex-direction: column;padding-bottom: .5rem;">
                    <div style="font-weight: 600;display: flex;align-items: center;flex-wrap: wrap;">
                        <span style="font-size: 1.1rem;">{{hotel?.name}}</span>
                        <span style="margin-left: .3rem;white-space: nowrap;">
                            <mat-icon  style="color:var(--cl-bg-color);font-size: 1.2rem;" *ngFor="let cat of categoryAr;">{{cat ===
                                1 ? 'star': 'star_half'}}</mat-icon>
                        </span>
                    </div>
                    <span style="font-size: .8rem;display: flex;align-items: center;" class="clicable"
                        (click)="openMaps()">
                        <mat-icon  style="margin-right: .1rem;font-size: .8rem;width: unset;height: unset;">room
                        </mat-icon>{{hotel?.location?.name}}
                        ({{hotel?.location?.region?.name}}) {{hotel?.country?.name}}
                    </span>
                </div>

                <ng-container *ngIf="hotel?.rating?.overall || hotel?.rating?.count">
                    <div class="clicable"
                        style="display: flex;border-block-color: #1b1c4acc;border: 1px #1b1c4acc solid;align-items: center;width: max-content;"
                        (click)="openReview()">
                        <div style="display: flex;align-items: center;background-color: #1b1c4acc;color:#fff;">
                            <mat-icon  style="font-size: 1rem;transform: translate(8px, 5px);;">
                                thumb_up_alt</mat-icon>
                            <span *ngIf="hotel?.rating?.overall"
                                style="margin-left: .3rem;margin-right: .3rem;">{{hotel?.rating.overall}}%</span>
                        </div>

                        <span *ngIf="hotel?.rating?.count"
                            style="margin-left: .3rem;font-size: .8rem;margin-right: .3rem;">({{hotel?.rating.count}}
                            Bewertungen)</span>
                    </div>
                </ng-container>
                <div style="display: flex;">
                    <span style="font-size: .75rem;">{{hotel?.catalogData?.previewText}}</span>
                </div>
            </div>
            <div *ngIf="hotel?.keywordList?.length > 0">
                <keywords [data]="hotel?.keywordList" class="keywordList"></keywords>
            </div>
            <ng-container *ngIf="alternativeCatalogList?.length > 0 && data.alternatives">
                <div style="display: flex;width: 100%;margin-top: 1rem;flex-direction: column;">
                    <span style="color: #545454eb;font-weight: 900;font-size: 1rem;">Anbieterinformation von</span>
                    <ng-container *ngTemplateOutlet="tourinfo"></ng-container>
                </div>
            </ng-container>
        </div>
    </div>

</ng-template>

<ng-template #tourinfo>
    <div style="display: flex;padding: 1rem;background-color: #0000000a;margin-top: .5rem;">
        <div style="display: flex;align-items: center;width: 100%;"
            [style.flex-direction]="desktopTemplate === 'sm' || desktopTemplate === 'xs' || desktopTemplate === 'md'  ? 'column' : 'row'">
            <mat-form-field style="max-width: 100%;">
                <mat-label>Katalog</mat-label>
                <mat-select (selectionChange)="getCatalogDataFromGiata($event);" [(ngModel)]="selectedtourcode">
                    <mat-option *ngFor="let cat of alternativeCatalogList" [value]="cat.code">
                        <div style="display: flex;align-items: center;">
                            <span>{{cat.name}} ({{cat.code}})</span>
                            <img class="lazyload" data-src="{{cat?.logo}}" height="15" style="margin-left: .5rem;" alt="image">
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field style="width: 100%;"
                [style.margin-left]="desktopTemplate === 'sm' || desktopTemplate === 'xs' || desktopTemplate === 'md' ? '' : '.5rem'">
                <mat-label>Katalogname</mat-label>
                <input matInput [value]="currenttourcode?.catalogName">
            </mat-form-field>
        </div>
    </div>
</ng-template>

<ng-template #touraddress>
    <div style="display: flex;padding: 1rem;background-color: #0000000a;margin-top: .5rem;">
        <ng-container *ngIf="desktopTemplate === 'lg' || desktopTemplate === 'xl'">
            <ng-container *ngTemplateOutlet="bigaddress"></ng-container>
        </ng-container>
        <ng-container *ngIf="desktopTemplate === 'md'">
            <ng-container *ngTemplateOutlet="mdaddress"></ng-container>
        </ng-container>
        <ng-container *ngIf="desktopTemplate === 'xs' || desktopTemplate === 'sm'">
            <ng-container *ngTemplateOutlet="xssmaddress"></ng-container>
        </ng-container>
    </div>
</ng-template>

<ng-template #bigaddress>
    <div style="display: flex;width: 100%;flex-direction: column;">
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="max-width: 33%;">
                <mat-label>Straße und Hausnummer</mat-label>
                <input matInput [value]="hotel?.address?.street">
            </mat-form-field>
            <mat-form-field style="margin-left: .5rem;width: 33%;">
                <mat-label>Postleitzahl</mat-label>
                <input matInput [value]="hotel?.address?.zipCode">
            </mat-form-field>
            <mat-form-field style="margin-left: .5rem;width: 33%;">
                <mat-label>Stadt</mat-label>
                <input matInput [value]="hotel?.address?.city + ' (' + hotel?.address?.country + ')'">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 33%;">
                <mat-label>Telefon</mat-label>
                <input matInput [value]="hotel?.address?.phone">
            </mat-form-field>
            <mat-form-field style="margin-left: .5rem;width: 33%;">
                <mat-label>Fax</mat-label>
                <input matInput [value]="hotel?.address?.fax">
            </mat-form-field>
            <mat-form-field style="margin-left: .5rem;width: 33%;">
                <mat-label>E-Mail</mat-label>
                <input matInput [value]="hotel?.address?.email">
            </mat-form-field>
        </div>
    </div>
</ng-template>

<ng-template #mdaddress>
    <div style="display: flex;width: 100%;flex-direction: column;">
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="max-width: 50%;">
                <mat-label>Straße und Hausnummer</mat-label>
                <input matInput [value]="hotel?.address?.street">
            </mat-form-field>
            <mat-form-field style="margin-left: .5rem;width: 50%;">
                <mat-label>Postleitzahl</mat-label>
                <input matInput [value]="hotel?.address?.zipCode">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 50%;">
                <mat-label>Stadt</mat-label>
                <input matInput [value]="hotel?.address?.city + ' (' + hotel?.address?.country + ')'">
            </mat-form-field>
            <mat-form-field style="margin-left: .5rem;width: 50%;">
                <mat-label>Telefon</mat-label>
                <input matInput [value]="hotel?.address?.phone">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 50%;">
                <mat-label>Fax</mat-label>
                <input matInput [value]="hotel?.address?.fax">
            </mat-form-field>
            <mat-form-field style="margin-left: .5rem;width: 50%;">
                <mat-label>E-Mail</mat-label>
                <input matInput [value]="hotel?.address?.email">
            </mat-form-field>
        </div>
    </div>
</ng-template>

<ng-template #xssmaddress>
    <div style="display: flex;width: 100%;flex-direction: column;">
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="max-width: 100%;">
                <mat-label>Straße und Hausnummer</mat-label>
                <input matInput [value]="hotel?.address?.street">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Postleitzahl</mat-label>
                <input matInput [value]="hotel?.address?.zipCode">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Stadt</mat-label>
                <input matInput [value]="hotel?.address?.city + ' (' + hotel?.address?.country + ')'">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Telefon</mat-label>
                <input matInput [value]="hotel?.address?.phone">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>Fax</mat-label>
                <input matInput [value]="hotel?.address?.fax">
            </mat-form-field>
        </div>
        <div style="display: flex;align-items: center;width: 100%;">
            <mat-form-field style="width: 100%;">
                <mat-label>E-Mail</mat-label>
                <input matInput [value]="hotel?.address?.email">
            </mat-form-field>
        </div>
    </div>
</ng-template>

<ng-template #sktvhotelinfo>
    <div style="display: flex;flex-direction: column;">
        <ng-container *ngIf="sktvContent?.producttype">
            <div style="display: flex;margin: .5rem;flex-direction: column;">
                <span style="font-size: 1.2rem;font-weight: 900;color:var(--cl-bg-color);text-transform: uppercase;"
                    [innerHTML]="sktvContent?.producttype | safehtml"></span>
            </div>
        </ng-container>
        <div style="display: flex;margin: .5rem;justify-content: space-between;"
            [style.flex-direction]=" desktopTemplate === 'sm' || desktopTemplate === 'xs' || desktopTemplate === 'md'  ? 'column' : 'row'">
            <div style="display: flex;flex-direction: column;font-size: 0.9rem;">
                <span *ngIf="sktvContent?.name?.length > 0"
                    style="font-size: 1.5rem;font-weight: 400;display:flex;align-items: center;">
                    <div style="margin-right: 0.5rem;" [innerHTML]="sktvContent.name | safehtml"></div>
                </span>
                <span *ngIf="sktvContent?.location?.length > 0" style="display: flex;align-items: center;">
                    <mat-icon  style="font-size: 1.3rem;transform: translate(0px, 2px);">room</mat-icon>
                    <div [innerHTML]="sktvContent.location | safehtml"></div>
                </span>
                <span *ngIf="sktvContent?.duration?.length > 0" style="display: flex;align-items: center;">
                    <mat-icon  style="font-size: 1.3rem;transform: translate(0px, 2px);">av_timer</mat-icon>
                    <span style="margin-right: 0.5rem;">Dauer:</span>
                    <div [innerHTML]="sktvContent.duration | safehtml"></div>
                </span>
            </div>
            <ng-container *ngTemplateOutlet="price"></ng-container>
        </div>
    </div>

    <ng-container *ngIf="sktvContent?.advantage">
        <div
            style="display: flex;flex-direction: column;margin: .5rem;border: 1px solid var(--cl-bg-color);padding: 0.5rem;font-size: 0.9rem;">
            <span style="font-size: 1.2rem;font-weight: 700;color:var(--cl-bg-color);">Ihre Vorteile auf einen
                Blick:</span>
            <div style="display: flex;width: 100%;flex-direction: column;">
                <div class="vorteile" [innerHTML]="sktvContent?.advantage | safehtml"></div>
                <span style="color:var(--cl-bg-color);font-weight: 600;width:100%;">
                    <mat-icon  style="font-size: 1.3rem;transform: translate(0px, 5px);">warning</mat-icon>
                    Buchbar nur bis : {{sktvContent?.validtodate}}
                </span>
            </div>
        </div>
    </ng-container>

    <div style="display: flex;flex-direction: column;margin: .5rem;font-size: 0.9rem;">
        <span style="font-weight: 900;font-size: 1.2rem;">Videos und Bilder</span>
        <div style="display: flex;flex-wrap: wrap;width: 100%;">
            <ng-template [ngIf]="sktvContent?.video?.length > 0">
                <div style="display: flex;background-size: cover;"
                    [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '70%' : '100%'">
                    <div style="width: 100%;">
                        <video width="100%" height="100%" controls>
                            <source src="{{sktvContent.video[0] + '#t=0.001'}}">
                            Your browser does not support HTML video.
                        </video>
                    </div>
                </div>
                <ng-container *ngTemplateOutlet="sktvContent?.images?.length > 0 ? images: videos">
                </ng-container>

            </ng-template>
            <ng-template [ngIf]="!(sktvContent?.video?.length > 0) && sktvContent?.images?.length > 0">
                <div style="display: flex;background-size: cover;height: 100%;"
                    [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '70%' : '100%'">
                    <img class="lazyload" width="100%" *ngIf="sktvContent?.images[0]" data-src="{{sktvContent?.images[0]}}" alt="image" (error)="handelError(0)">
                </div>
                <div style="display: flex;height: 100%;" [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '30%' : '100%'"
                    [style.flex-direction]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? 'column': 'row'">
                    <div style="display: flex;background-size: cover;" [style.height]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '50%' : '60%'"
                        [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '100%' : '50%'">
                        <img class="lazyload" width="100%" *ngIf="sktvContent?.images[1]" data-src="{{sktvContent?.images[1]}}" alt="image" (error)="handelError(1)">
                    </div>
                    <div style="display: flex;background-size: cover;position: relative;"
                        [style.height]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '50%' : '60%'"
                        [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '100%' : '50%'">
                        <img class="lazyload" width="100%" *ngIf="sktvContent?.images[2]" data-src="{{sktvContent?.images[2]}}" alt="image" (error)="handelError(2)">
                        <ng-container *ngTemplateOutlet="videoimagelink"></ng-container>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>

    <ng-container *ngIf="sktvContent?.description?.sktv_content_1?.length > 0">
        <div style="display: flex;flex-direction: column;margin-top: 1rem;padding: 0.5rem;font-size: 0.9rem;">
            <span style="font-weight: 900;font-size: 1.2rem;">Leistungen:</span>
            <div style="display: flex;flex-direction: column;background: #0000000a;padding: 0.5rem;">
                <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                    [innerHTML]="sktvContent.description.sktv_content_1 | safehtml">
                </div>

            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="sktvContent?.description?.accommodation?.text?.length > 0">
        <div style="display: flex;flex-direction: column;margin-top: 1rem;padding: 0.5rem;font-size: 0.9rem;">
            <span style="font-weight: 900;font-size: 1.2rem;">Hotelinformationen</span>
            <div style="display: flex;flex-direction: column;background: #0000000a;padding: 0.5rem;">
                <span *ngIf="sktvContent.description.accommodation.titel"
                    style="font-weight: 900;font-size: 1rem;padding: 0.5rem;">{{sktvContent.description.accommodation.titel}}</span>
                <mat-divider></mat-divider>
                <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                    style="padding: 0.5rem;" [innerHTML]="sktvContent.description.accommodation.text | safehtml"></div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="sktvContent?.description?.itinerary?.text?.length > 0 ||
                sktvContent?.description?.leisuretips?.text?.length > 0 ||
                sktvContent?.description?.leisuretips?.text?.length > 0 ||
                sktvContent?.description?.children?.text?.length > 0 ||
                sktvContent?.description?.legalnote?.text?.length > 0 ||
                sktvContent?.description?.notices?.text?.length > 0">
        <div style="display: flex;flex-direction: column;margin-top: 1rem;font-size: 0.9rem;padding: 0.5rem;">
            <span style="font-weight: 900;font-size: 1.2rem;padding: 0.5rem;">Reiseinformationen</span>
            <div style="display: flex;flex-direction: column;background: #0000000a;padding: 1rem;">
                <mat-tab-group animationDuration="0">
                    <ng-container *ngIf="sktvContent.description.itinerary?.text?.length > 0">
                        <mat-tab [label]="sktvContent.description.itinerary.titel" isActive="false">
                            <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                                style="padding: 0.5rem;font-size: 0.9rem;"
                                [innerHTML]="sktvContent.description.itinerary.text"></div>
                        </mat-tab>
                    </ng-container>
                    <ng-template [ngIf]="sktvContent.description.regioninfo?.text?.length > 0">
                        <mat-tab label="{{sktvContent.description.regioninfo.titel}}" isActive="false">
                            <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                                style="padding: 0.5rem;" [innerHTML]="sktvContent.description.regioninfo.text | safehtml">
                            </div>
                        </mat-tab>
                    </ng-template>
                    <ng-template [ngIf]="sktvContent.description.notices?.text?.length > 0">
                        <mat-tab label="{{sktvContent.description.notices.titel}}">
                            <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                                style="padding: 0.5rem;" [innerHTML]="sktvContent.description.notices.text | safehtml">
                            </div>
                        </mat-tab>
                    </ng-template>
                    <ng-template [ngIf]="sktvContent.description.children?.text?.length > 0">
                        <mat-tab label="{{sktvContent.description.children.titel}}">
                            <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                                style="padding: 0.5rem;" [innerHTML]="sktvContent.description.children.text | safehtml">
                            </div>
                        </mat-tab>
                    </ng-template>
                    <ng-template [ngIf]="sktvContent.description.leisuretips?.text?.length > 0">
                        <mat-tab label="{{sktvContent.description.leisuretips.titel}}">
                            <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                                style="padding: 0.5rem;" [innerHTML]="sktvContent.description.leisuretips.text | safehtml">
                            </div>
                        </mat-tab>
                    </ng-template>
                    <ng-template [ngIf]="sktvContent.description.legalnote?.text?.length > 0">
                        <mat-tab [label]="sktvContent.description.legalnote.titel">
                            <div class="vorteile" [style.column-count]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '2' : '1'"
                                style="padding: 0.5rem;" [innerHTML]="sktvContent.description.legalnote.text | safehtml">
                            </div>
                        </mat-tab>
                    </ng-template>
                </mat-tab-group>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="sktvContent?.orderId?.length > 0">
        <div style="display: flex;flex-direction: column;margin-top: 1rem;padding: 0.5rem;font-size: 0.9rem;">
            <div style="display: flex;flex-direction: column;background:#545454;;color:#fff;padding: 1rem;">
                <span style="font-weight: 700;font-size: 1.1rem;width: 100%;padding: 0.5rem;">Wir sind für Sie
                    da</span>
                <div style="display: flex;" [style.flex-direction]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? 'row' : 'column'">
                    <div style="display: flex;flex-direction: column;">
                        <div style="padding: 0.5rem;">Wenn Sie Unterstützung mit diesem Produkt brauchen, dann
                            wenden
                            Sie sich bitte an unsere Hotline:</div>
                        <span style="font-weight: 700;font-size: 1.3rem;padding: 0.5rem;"
                            *ngIf="partner?.tel?.length > 0">Hotline: {{partner.tel}}</span>
                    </div>
                    <div style="display: flex;flex-direction: column;">
                        <div style="padding: 0.5rem;">Zur Identifikation des Produktes nennen Sie dem Support
                            Mitarbeiter bitte folgende Bestellnummer:</div>
                        <span style="font-weight: 700;font-size: 1.3rem;padding: 0.5rem;">TV-Bestellnummer:
                            {{sktvContent?.orderId}}</span>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <div style="display: flex;flex-direction: column;">
                    <span style="font-weight: 400;font-size: 0.7rem;padding: 0.5rem;">*In diesem Content verwenden wir
                        als Vertragspartner die uns zur Verfügung gestellte Medieninhalte der sonnenklar.TV, EUVIA
                        TRAVEL GmbH, TVG Touristik Vertriebsgesellschaft mbH</span>
                </div>
            </div>
            <div style="display: flex;justify-content: flex-end;align-items: center;width: 100%;">
                <ng-container *ngTemplateOutlet="price"></ng-container>
            </div>
        </div>
    </ng-container>

    <ng-template #images>
        <div style="display: flex;height: 100%;" [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '30%' : '100%'"
            [style.flex-direction]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? 'column': 'row'">
            <div style="display: flex;background-size: cover;" [style.height]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '50%' : '150px'"
                [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '100%' : '50%'">
                <img class="lazyload" width="100%" *ngIf="sktvContent?.images[0]?.length > 0" data-src="{{sktvContent?.images[0]}}" alt="image" (error)="handelError(0)">
            </div>
            <div style="display: flex;background-size: cover;position: relative;"
                [style.height]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '50%' : '150px'" [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '100%' : '50%'">
                <img class="lazyload" width="100%" *ngIf="sktvContent?.images[1]?.length > 0" data-src="{{sktvContent?.images[1]}}" alt="image" (error)="handelError(1)">
                <ng-container *ngTemplateOutlet="videoimagelink"></ng-container>
            </div>
        </div>
    </ng-template>
    <ng-template #videos>
        <div style="display: flex;" [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '30%' : '100%'"
            [style.flex-direction]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? 'column': 'row'">
            <div style="display: flex;background-size: cover;"
                [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '100%' : '50%'">
                <video width="100%" controls>
                    <source src="{{sktvContent.video[1] + '#t=0.001'}}">
                    Your browser does not support HTML video.
                </video>
            </div>
            <div style="display: flex;background-size: cover;" [style.height]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '57%' : '60%'"
                [style.width]="desktopTemplate === 'xl' || desktopTemplate === 'lg' ? '100%' : '50%'">
                <ng-container *ngTemplateOutlet="videoimagelink"></ng-container>
            </div>
        </div>
    </ng-template>

    <ng-template #videoimagelink>
        <div (click)="openImageModal(1)"
            style="height: 100%;width: 100%;background-color: #000000bd;display: flex;align-items: center;justify-content: center;cursor: pointer;position: absolute;">
            <span style="color: #fff;text-align: center;">Alle {{sktvContent?.images?.length}} Bilder &
                {{sktvContent?.video?.length}} Videos
                ansehen</span>
        </div>
    </ng-template>
    <ng-template #price>
        <div style="display: flex;flex-direction: column;justify-self: end;align-items: flex-end;padding: 2rem .5rem;"
            mat-dialog-close (click)="goToOffers()">
            <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <div style="display: flex;justify-content: center;align-items: end;padding:0.25rem;
                    background-color: var(--cl-bg-color);color: var(--cl-text-color);font-size: 1.2rem;position: relative;">
                    <div style="font-size: 0.7rem;">ab <span
                            style="font-size: 250%; font-weight: 400;">€{{sktvContent?.price | number}}</span>
                        p.P.
                    </div>

                    <div *ngIf="sktvContent?.oldPrice?.length > 0" class="mat-elevation-z1" style="display: flex;justify-content: center;align-items: center;padding:0.25rem;
                        background-color:#fff;color: var(--cl-bg-color);font-size: 0.8rem;position: absolute;top: -22px;">
                        <div style="font-size: 0.35rem;position:relative">ab <span
                                style="font-size: 250%; font-weight: 400;">€{{sktvContent?.oldPrice | number}}</span>
                            p.P.
                            <mat-icon  style="font-size: 1rem;transform: translate(5px, 1px);cursor:pointer;"
                                matTooltip="{{sktvContent?.savingstext}}" matTooltipPosition="above"
                                matTooltipClass="matTooltip">info
                            </mat-icon>
                            <div
                                style="position: absolute;background-color: #000;height: 1px;width:80%;top: 50%;transform: rotate(-15deg);">
                            </div>
                        </div>
                    </div>
                </div>
                <div style="display: flex;justify-content: center;align-items: center;cursor: pointer;margin-left: 0.5rem;padding: 0 1rem;
                    background-color:#545454;color: #fff;font-size: 1.2rem;font-weight:500;position: relative;"
                    mat-dialog-close (click)="goToOffers()">
                    Zu allen Terminen
                </div>
            </div>
        </div>
    </ng-template>
</ng-template>